// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__BNp9E","rootNoMargin":"styles_rootNoMargin__1--lo"};